import { render } from "./OtherSettingsBlock.vue?vue&type=template&id=747656a6"
import script from "./OtherSettingsBlock.vue?vue&type=script&lang=js"
export * from "./OtherSettingsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__